import { Component, Inject, Vue, Watch } from "vue-property-decorator";
import { FormTemplateService } from "./services/FormTemplateService";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import {
  CHART_DATA,
  FORM_FILTERS_LIST,
  FORM_TEMPLATES_ACCESS,
  FORM_TEMP_CONSTANTS,
  KEYTYPE_CONSTANTS
} from "./constants/FormTemplateConstants";
import { Http } from "@status/codes";
import {
  COLLECTIONS_NAME,
  COMPONENT_NAME_MODAL,
  FORM_MESSAGES,
  LIST_DATA_EVENTS,
  LOCAL_STORAGE
} from "@/shared/constants/FormConstants";
import Snackbar from "../../shared/components/Snackbar/Snackbar";
import ModalTemplate from "@/shared/components/ModalTemplate/ModalTemplate.vue";
import ObservationModal from "@/shared/components/ObservationModal/ObservationModal.vue";
import FormModalViewer from "@/shared/components/FormModalViewer/FormModalViewer.vue";
import { FormTemplateData } from "@/modules/FormTemplate/models/FormTemplateData";
import { LIST_CONSTANTS } from "../List/constants/ListConstants";
import {
  CHART_TYPES,
  GENERAL_CONSTANTS,
  PANEL_INFO_CONSTANTS,
  STATE,
  STORE_CONSTANTS
} from "@/shared/constants/GeneralConstants";
import SaveFormTemplate from "./components/SaveFormTemplate/SaveFormTemplate.vue";
import { SearchContext } from "@/shared/models/SearchContext";
import { Filter } from "../Dashboards/AdminDashboard/models/Filter";
import store from "@/store";
import { mapGetters } from "vuex";
import { MenuDataStructure } from "@/shared/models/MenuDataStructure";
import { NavigationGuardNext, Route } from "vue-router";
import SaveList from "../List/components/SaveList/SaveList.vue";
import { QuerySearchFormTemplate } from "./models/QuerySearchFormTemplate ";
import { Utils } from "@/shared/utils/utils";
import CrudChart from "@/shared/components/CrudChart/CrudChart.vue";
import Vuetify from "vuetify";
import { CHART_INIT } from "../SessionTemplate/constants/SessionTemplateConstants";
import EmptyState from "@/shared/components/EmptyState/EmptyState.vue";
import { AxiosError } from "axios";

Vue.use(Vuetify);

Component.registerHooks(["beforeRouteLeave"]);
@Component({
  name: "FormTemplate",
  components: {
    ModalTemplate,
    ObservationModal,
    FormModalViewer,
    SaveFormTemplate,
    SaveList,
    CrudChart,
    EmptyState
  },
  computed: {
    ...mapGetters({
      dataToMainView: "getDataToMainView"
    })
  }
})
export default class FormTemplate extends Vue {
  @Inject() formTemplateService!: FormTemplateService;

  dataToMainView!: MenuDataStructure;

  btnClassPrimary = STYLE_CLASSES.PRIMARY_BTN;
  btnClassPrimaryRound = STYLE_CLASSES.PRIMARY_ROUND_BTN;
  cardClass = STYLE_CLASSES.CARD;
  SEARCH_TITLE = FORM_TEMP_CONSTANTS.PAGE_TITLE;
  TITLE_PAGE = FORM_TEMP_CONSTANTS.PAGE_TITLE;
  ADD_TEMPLATE_TEXT = FORM_TEMP_CONSTANTS.ADD_TEMPLATE_TEXT;
  EMPTY_STATE_HEADER = FORM_MESSAGES.INFO_MESSAGE.NO_INFO_TO_SHOW;
  EMPTY_STATE_PARAGRAPH = FORM_MESSAGES.INFO_MESSAGE.EMPTY_STATE_TEXT;
  CATEGORY_TEXT = FORM_TEMP_CONSTANTS.FORM_LABEL.CATEGORY;
  TYPE_TEXT = FORM_TEMP_CONSTANTS.FORM_LABEL.TYPE;
  STATUS_TEXT = FORM_TEMP_CONSTANTS.FORM_LABEL.STATUS;
  VERSION_TEXT = FORM_TEMP_CONSTANTS.FORM_LABEL.VERSION;
  DATE_CREATED_TEXT = FORM_TEMP_CONSTANTS.FORM_LABEL.DATE_CREATED;
  DATE_CHANGED_TEXT = FORM_TEMP_CONSTANTS.FORM_LABEL.DATE_CHANGED;
  observationModalTitle = FORM_MESSAGES.FORM_TEMPLATE_REASON_MODAL.TITLE;
  observationModalText = FORM_MESSAGES.FORM_TEMPLATE_REASON_MODAL.MESSAGE;
  modalTitle = FORM_MESSAGES.DELETE_MODAL.TITLE;
  modalText = FORM_MESSAGES.DELETE_MODAL.MESSAGE;
  ADD_LIST_BTN = LIST_CONSTANTS.BUTTON.ADD_LIST_TEXT;
  OPERATIONS = [LIST_DATA_EVENTS.VIEW_DATA];
  RESET_BTN = FORM_MESSAGES.RESET_TEXT;
  CHART_EMPTY_STATE_HEADER = "No se puede cargar la gráfica";
  CHART_EMPTY_STATE_PARAGRAPH = "No hay datos para visualizar en las gráficas";

  formTemplateData: FormTemplateData = new FormTemplateData();

  filterArray: Filter[] = FORM_FILTERS_LIST;

  canSearch = true;
  filterQuery: QuerySearchFormTemplate = {};
  loadingData = false;

  fields = [];
  dialogPreview = false;
  dateCreated = "";
  dateModified = "";
  clearModel = false;
  admin = false;
  showEmptyState = false;

  currentChartTypeIndex = 2;
  currentChartType = CHART_TYPES[this.currentChartTypeIndex].value;
  currentIcon = GENERAL_CONSTANTS.ICONS.ADD;
  currentTooltip = FORM_TEMP_CONSTANTS.TOOLTIP_ADD_BTN;
  formTemplateIdProp = "";

  categoriesChartData = CHART_INIT;
  stateChartData = CHART_INIT;

  roundBtnClassTertiary = STYLE_CLASSES.TERTIARY_ROUND_BTN;
  TOOLTIP = FORM_TEMP_CONSTANTS.TOOLTIP;
  chartTypes = CHART_TYPES;
  isLoadingCharts = true;
  isVisibleSaveFormTemplate = false;
  formTempIdCopy = "";
  showModalAddList = false;
  formTemplates: [] = [];
  keyForm = 1;

  actionCancel = COMPONENT_NAME_MODAL.FORM_TEMPLATE;

  async mounted() {
    const views = localStorage.getItem(LOCAL_STORAGE.VIEWS);

    if (
      (JSON.parse(views as string) as string[]).includes(
        LOCAL_STORAGE.ADMIN_ROLE
      )
    ) {
      this.admin = true;
    }

    this.OPERATIONS = Utils.addExtraOperations(
      this.OPERATIONS,
      COLLECTIONS_NAME.FORM_TEMPLATE
    );

    await this.emitSearchInitializer();
    await this.getTemplateData();
  }

  @Watch("dataToMainView")
  handleDataToMainView() {
    if (
      this.dataToMainView.from === PANEL_INFO_CONSTANTS.FROM.PANEL &&
      this.dataToMainView.type === PANEL_INFO_CONSTANTS.TYPE.SEARCH
    ) {
      switch (this.dataToMainView.action) {
        case PANEL_INFO_CONSTANTS.ACTION.DO_SEARCH_TEMPLATE:
          this.mapFilters(true, this.dataToMainView.data);
          this.getTemplateData();
          break;
        case PANEL_INFO_CONSTANTS.ACTION.SHOW_CRUD_SAVE:
          this.onButtonAdd();
          break;
      }
    } else if (
      this.dataToMainView.from === PANEL_INFO_CONSTANTS.FROM.PANEL &&
      this.dataToMainView.type === PANEL_INFO_CONSTANTS.TYPE.OPTIONS
    ) {
      if (
        this.dataToMainView.action === PANEL_INFO_CONSTANTS.ACTION.SHOW_ADD_LIST
      ) {
        this.showModalAddList = true;
      }
    }
  }

  async emitSearchInitializer() {
    const searchContext: SearchContext = {
      title: FORM_TEMP_CONSTANTS.PAGE_TITLE_SEARCH,
      filterArray: this.filterArray,
      operations: this.OPERATIONS,
      clickAction: LIST_DATA_EVENTS.EDIT_DATA,
      callbackHandleOperation: this.handleOperation,
      componentName: COMPONENT_NAME_MODAL.FORM_TEMPLATE,
      descriptions: ["category", "state"],
      textButtonCreate: FORM_TEMP_CONSTANTS.TOOLTIP_ADD_BTN
    };
    this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.SET_SEARCH_CONTEXT,
      searchContext
    );
  }

  async getTemplateData() {
    try {
      this.isLoadingCharts = true;
      this.loadingData = true;

      this.sendDataToLateralMenu(
        PANEL_INFO_CONSTANTS.ACTION.LOADING_CONTEXT_AND_HIDE_CARDS
      );

      const response = await this.formTemplateService.getFormTemplateWithFiltersArray(
        this.filterQuery
      );
      if (
        response.code === Http.Found &&
        response.data &&
        response.data.formTemplates.length > 0
      ) {
        this.sendDataToLateralMenu(
          PANEL_INFO_CONSTANTS.ACTION.SET_LIST_ITEM_CONTEXT,
          response.data.formTemplates
        );

        this.categoriesChartData = {
          chartTitle: CHART_DATA.CHART_TITLE.CATEGORY,
          chartRenderData: Utils.mapChartData(
            response.data.chartData,
            CHART_DATA.CHART_PARAM.CATEGORY
          )
        };
        this.stateChartData = {
          chartTitle: CHART_DATA.CHART_TITLE.STATE,
          chartRenderData: Utils.mapChartData(
            response.data.chartData,
            CHART_DATA.CHART_PARAM.STATE
          )
        };
        this.showEmptyState = false;
      } else {
        this.showEmptyState = true;
        this.sendDataToLateralMenu(
          PANEL_INFO_CONSTANTS.ACTION.RESET_SEARCH_CONTEXT
        );
      }
    } catch (error) {
      this.sendDataToLateralMenu(
        PANEL_INFO_CONSTANTS.ACTION.RESET_SEARCH_CONTEXT
      );
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + FORM_TEMPLATES_ACCESS.GET
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
      this.showEmptyState = true;
    }
    this.loadingData = false;
    this.isLoadingCharts = false;
  }

  mapFilters(newFilter?: boolean, querySearch?: QuerySearchFormTemplate) {
    if (newFilter) this.filterQuery = {};

    if (typeof querySearch !== KEYTYPE_CONSTANTS.UNDEFINED) {
      if (querySearch?.name) this.filterQuery.name = querySearch.name;
      if (querySearch?.type) this.filterQuery.type = querySearch.type;
      if (querySearch?.state) this.filterQuery.state = querySearch.state;
      if (querySearch?.category)
        this.filterQuery.category = querySearch.category;
    }
  }

  async handleOperation(action: string, itemId: string) {
    switch (action) {
      case LIST_DATA_EVENTS.VIEW_DATA:
        await this.showFormTemplateDetails(itemId);
        break;
      case LIST_DATA_EVENTS.EDIT_DATA:
        this.showFormTemplate(itemId, FORM_TEMP_CONSTANTS.EDITAR_FORMULARIO);
        break;
      case LIST_DATA_EVENTS.DELETE_DATA:
        this.deleteFormTemp(itemId);
        this.actionCancel = COMPONENT_NAME_MODAL.FORM_TEMPLATE;
        this.cancelAction();
        break;
      case LIST_DATA_EVENTS.ACTIVE_DATA:
        this.stateUpdateFormTemplate(itemId, STATE.ACTIVE);
        this.actionCancel = COMPONENT_NAME_MODAL.FORM_TEMPLATE;
        this.cancelAction();
        break;
      case LIST_DATA_EVENTS.DESACTIVED_DATA:
        this.stateUpdateFormTemplate(itemId, STATE.INACTIVE);
        this.actionCancel = COMPONENT_NAME_MODAL.FORM_TEMPLATE;
        this.cancelAction();
        break;
      case LIST_DATA_EVENTS.CANCEL_DATA:
        this.cancelAction();
        break;
    }
  }

  cancelAction() {
    switch (this.actionCancel) {
      case COMPONENT_NAME_MODAL.FORM_TEMPLATE:
        this.formTemplateIdProp = "";
        this.show(false);
        break;
      case COMPONENT_NAME_MODAL.LIST:
        this.showModalAddList = false;
    }
  }

  async deleteFormTemp(id: string) {
    try {
      const responseData = await this.formTemplateService.deleteFormTemp(id);

      if (responseData.code === Http.Ok) {
        Snackbar.popSuccess(responseData.message);
        await this.getTemplateData();
      } else if (responseData.code === Http.Found) {
        Snackbar.popWarning(responseData.message);
      } else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + FORM_TEMPLATES_ACCESS.DELETE
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async showFormTemplateDetails(itemId: string) {
    try {
      const response = await this.formTemplateService.getFormTemplateSchemaById(
        itemId
      );

      if (response.code === Http.Found && response.data != null) {
        this.formTemplateData = response.data;

        this.dateCreated = this.formTemplateData.dateCreated
          ? new Date(this.formTemplateData.dateCreated).toLocaleString("es-CO")
          : "";

        this.dateModified = this.formTemplateData.dateChanged
          ? new Date(this.formTemplateData.dateChanged).toLocaleString("es-CO")
          : "";

        this.dialogPreview = true;
        this.clearModel = true;
      } else {
        Snackbar.popInfo(response.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + FORM_TEMPLATES_ACCESS.GET
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async stateUpdateFormTemplate(documentId: string, state: string) {
    try {
      const responseData = await this.formTemplateService.updateStateFormTemplateById(
        documentId,
        state
      );

      if (responseData.code === Http.Ok) {
        Snackbar.popSuccess(responseData.message);
        await this.getTemplateData();
      } else if (responseData.code === Http.NotFound) {
        Snackbar.popError(
          FORM_TEMP_CONSTANTS.DIALOG_MESSAGE.ERROR_ID_NOT_FOUND
        );
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + FORM_TEMPLATES_ACCESS.PUT
        );
      else Snackbar.popError(FORM_TEMP_CONSTANTS.DIALOG_MESSAGE.ERROR);
    }
  }

  closeModalPreview() {
    this.dialogPreview = false;
    this.clearModel = false;
  }

  changeChartType(chartType: string) {
    this.currentChartType = chartType;
  }

  onButtonAdd() {
    this.showFormTemplate("", FORM_TEMP_CONSTANTS.CREAR_FORMULARIO);
  }

  showFormTemplate(id: string, accion: string) {
    if (accion === FORM_TEMP_CONSTANTS.CREAR_FORMULARIO) {
      if (this.currentIcon === GENERAL_CONSTANTS.ICONS.ADD) {
        this.formTemplateIdProp = "";
        this.TITLE_PAGE = FORM_TEMP_CONSTANTS.ADD_PAGE_TITLE;
        this.show(true);
        this.sendDataToLateralMenu(
          PANEL_INFO_CONSTANTS.ACTION.SET_SELECTED_ITEM_NULL,
          { showOptions: this.isVisibleSaveFormTemplate }
        );
        Utils.scrollToElement(FORM_TEMP_CONSTANTS.SAVE_FORM_MODAL_ID, this);
      } else {
        this.actionCancel = COMPONENT_NAME_MODAL.FORM_TEMPLATE;
        this.sendDataToLateralMenu(PANEL_INFO_CONSTANTS.ACTION.MODAL_CANCEL);
      }
    } else if (accion === FORM_TEMP_CONSTANTS.EDITAR_FORMULARIO) {
      this.formTemplateIdProp = id;
      this.sendDataToLateralMenu(
        PANEL_INFO_CONSTANTS.ACTION.SET_SELECTED_ITEM,
        id
      );
      this.show(true);
      this.TITLE_PAGE = FORM_TEMP_CONSTANTS.EDIT_PAGE_TITLE;
      Utils.scrollToElement(FORM_TEMP_CONSTANTS.SAVE_FORM_MODAL_ID, this);
    } else {
      this.formTemplateIdProp = id;
      this.show(false);
    }
  }

  show(val: boolean) {
    this.isVisibleSaveFormTemplate = val;
    if (val) {
      this.currentIcon = GENERAL_CONSTANTS.ICONS.CANCEL;
      this.currentTooltip = FORM_TEMP_CONSTANTS.TOOLTIP_CANCEL_BTN;
    } else {
      this.currentIcon = GENERAL_CONSTANTS.ICONS.ADD;
      this.currentTooltip = FORM_TEMP_CONSTANTS.TOOLTIP_ADD_BTN;
      this.formTemplateIdProp = "";
      this.setName(this.SEARCH_TITLE);
      this.getTemplateData();
      this.resetFilters();
      this.keyForm++;
      this.sendDataToLateralMenu(
        PANEL_INFO_CONSTANTS.ACTION.SET_SELECTED_ITEM,
        ""
      );
    }
  }

  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  sendDataToLateralMenu(action: string, data?: any) {
    store.commit(STORE_CONSTANTS.TO_LATERAL_MENU, {
      from: PANEL_INFO_CONSTANTS.FROM.CRUD,
      type: PANEL_INFO_CONSTANTS.TYPE.SEARCH,
      action: action,
      data: data
    });
  }

  async beforeRouteLeave(to: Route, from: Route, next: NavigationGuardNext) {
    await this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.DISABLE_SEARCH_CONTEXT
    );
    next();
  }

  setName(name: string) {
    this.TITLE_PAGE = name;
  }

  reset() {
    this.formTemplateIdProp = "";
    this.show(false);
    this.setName(this.SEARCH_TITLE);
    this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.RESET_SEARCH_CONTEXT
    );
  }

  resetFilters() {
    this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.RESET_SEARCH_CONTEXT
    );
  }

  async clickDataCategory(label: string) {
    const graphFilter: QuerySearchFormTemplate = {
      ...this.filterQuery,
      category: [label]
    };
    this.mapFilters(false, graphFilter);
    await this.getTemplateData();
  }

  async clickOutCategory() {
    delete this.filterQuery.category;
    await this.getTemplateData();
  }

  async clickDataState(label: string) {
    const graphFilter: QuerySearchFormTemplate = {
      ...this.filterQuery,
      state: [label]
    };
    this.mapFilters(false, graphFilter);
    await this.getTemplateData();
  }

  async clickOutState() {
    delete this.filterQuery.state;
    await this.getTemplateData();
  }
}
